import {
  AndroidOutlined,
  ApartmentOutlined,
  AppleOutlined,
  CaretDownFilled,
  DownOutlined,
  FilterOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  TableOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Tooltip, Button, Dropdown, Menu, Tag, Tabs } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import AddPerfCycleModal from "../../components/modal/add/AddPerfCycleModal";
import AddTopPlanModal from "../../components/modal/add/AddTopPlanModal";
import AddUnitModal from "../../components/modal/add/AddUnitModal";
import OrganizationFilterModal from "../../components/modal/filters/OrganizationFilterModal";
import PerfCycleFilterModal from "../../components/modal/filters/PerfCycleFilterModal";
import Cascades from "../../components/perf-cycle/Cascades";
import Overview from "../../components/perf-cycle/Overview";
import Plans from "../../components/perf-cycle/Plans";
import OrganizationTable from "../../components/tables/OrganizationTable";
import PerfCycleTable from "../../components/tables/PerfCyclesTable";
import OrganizationTree from "../../components/tree/OrganizationTree";

const { TabPane } = Tabs;

function PerformanceCycle() {
  const [data, setData] = useState("");
  const [tree, setTree] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);
  const proHeight = document.body.clientHeight;
  let navigate = useNavigate();

  function toSettings() {
    navigate("/settings/plan-levels");
  }

  const right = (
    <>
      {data && !tree && (
        <Tooltip title={"Filter"}>
          <Button onClick={() => setFilterModal(true)} className="mr-3">
            <FilterOutlined />
          </Button>
        </Tooltip>
      )}
      <Tooltip title={"Settings"}>
        <Button onClick={() => toSettings()} className="mr-3">
          <SettingOutlined />
        </Button>
      </Tooltip>
      <Tooltip placement="left" title={"Add objective"}>
        <Button
          onClick={() => setAddModal(true)}
          shape="circle"
          type="primary"
          icon={<PlusOutlined />}
        ></Button>
      </Tooltip>
    </>
  );

  const left = (
    <div className="pri-font text-lg">
      Cycle Name{" "}
      <Tag className="uppercase" color={"green"}>
        Active
      </Tag>
    </div>
  );

  function showEmptyCompanies() {
    return (
      <div className="flex justify-center items-center w-full h-full">
        <div className="text-center">
          <div className="text-3xl text-gray-400">
            <WarningOutlined />
          </div>
          <div className="text-xl pri-font text-gray-400">
            No performance cycle available
          </div>
          <div className="mb-3 text-gray-400">
            Add your first performance cycle for the organization
          </div>
          <Button onClick={() => setAddModal(true)} type="primary">
            Add a cycle
          </Button>
        </div>
      </div>
    );
  }

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll"
        >
          <Tabs defaultActiveKey="1" centered>
            <TabPane
              tab={<div className="w-32 text-center">Overview</div>}
              key="1"
            >
              <div className="px-6">
                <Overview />
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32 text-center">Plans</div>}
              key="2"
            >
              <div className="px-6">
                <Plans />
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32 text-center">Hierarchy</div>}
              key="3"
            >
              <div className="px-6">
                <Cascades />
              </div>
            </TabPane>
            <TabPane
              tab={<div className="w-32 text-center">Objectives</div>}
              key="4"
            >
              <div className="px-6">
                <Cascades />
              </div>
            </TabPane>
          </Tabs>
        </div>
      </Content>
      <AddTopPlanModal
        visible={addModal}
        handleCancel={() => setAddModal(false)}
      />
    </>
  );
}

export default PerformanceCycle;
